import { create } from "zustand";

import { DEFAULT_PAGINATION_LIMIT } from "../../../../../../../../../globalConstants";

export const useProCliStore = create((set) => ({
  limit: DEFAULT_PAGINATION_LIMIT,
  orderingVal: "provider_name",
  shouldFetchData: true,
  providersData: new Map(),
  status: {
    finished_treatment: "",
    medical_documents_status: "",
    provider_transportation: "",
    hns_transportation: "",
  },

  setShouldFetchData: (shouldFetchData) => {
    return set((state) => ({
      ...state,
      shouldFetchData: shouldFetchData,
    }));
  },

  setProvidersData: (providersData) => {
    return set((state) => ({
      ...state,
      providersData: providersData,
    }));
  },

  setLimit: (newLimit) => {
    return set((state) => ({
      ...state,
      limit: newLimit,
    }));
  },
}));
